import { inject } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { ActivatedRouteSnapshot, ResolveFn, Routes } from '@angular/router';
import UserRouteAccessService from 'app/core/auth/user-route-access-service';
import {
  Observable, of
} from 'rxjs';
import {
  filter, map
} from 'rxjs/operators';
import {
  CustomerStatementRx, ICustomerStatementRx
} from 'app/shared/model/customer-statement-rx.model';
import CustomerStatementRxService from './customer-statement-rx.service';
import CustomerStatementRxComponent from './customer-statement-rx.component';
import ResolvePagingParams from '../resolve-paging-params.service';

export const CustomerStatementRxResolve: ResolveFn<ICustomerStatementRx> = (route: ActivatedRouteSnapshot): Observable<ICustomerStatementRx> => {
  const { id } = route.params;
  if (id) {
    return inject(CustomerStatementRxService).find(id).pipe(
      filter((response: HttpResponse<CustomerStatementRx>) => response.ok),
      map((customerStatement: HttpResponse<CustomerStatementRx>) => customerStatement.body)
    );
  }
  return of(new CustomerStatementRx());
};

export const customerStatementRoute: Routes = [
  {
    path: '',
    component: CustomerStatementRxComponent,
    resolve: {
      pagingParams: ResolvePagingParams
    },
    data: {
      authorities: ['ROLE_USER'],
      defaultSort: 'id,asc',
      pageTitle: 'bjcrxApp.customerStatement.home.title'
    },
    canActivate: [UserRouteAccessService]
  }
];
